import { Pagination, Stack } from '@optimus-web/core';
import { useCityLedgerPagination } from '../../../context/CityLedgerFilterContext';
import { PaginationSizeElement } from './PaginationSizeElement';

export const CityLedgerPagination = ({ totalRowCount }: { totalRowCount: number }) => {
    const { pagination, setPagination } = useCityLedgerPagination();

    const handlePaginationUpdate = (value: number) => {
        setPagination((prev) => ({
            ...prev,
            pageIndex: value,
        }));
    };

    const totalPages = Math.ceil(totalRowCount / pagination.pageSize) || -1;

    return totalPages > 1 ? (
        <Stack distribution="space-between" data-test-id="city-ledger-pagination">
            <Stack itemAlignment="center" spacing="100">
                <PaginationSizeElement totalRowCount={totalRowCount} />
            </Stack>
            {totalPages > 0 && (
                <Pagination
                    data-test-id="pagination-state"
                    size={totalPages}
                    selected={pagination.pageIndex}
                    onClick={handlePaginationUpdate}
                    alignment="end"
                />
            )}
        </Stack>
    ) : null;
};
